import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  paymentStatements: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const paymentStatementSlice = createSlice({
  name: 'paymentStatements',
  initialState: initialState,
  reducers: {
    setPaymentStatements: (state, { payload }) => {
      state.paymentStatements = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMorePaymentStatements: (state, { payload }) => {
      state.paymentStatements = state.paymentStatements.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removePaymentStatement: (state, { payload }) => {
      state.error = payload
    },
    clearAllPaymentStatement: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const fetchPaymentStatements = (page, params, disableLoader, Async) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchAdminInterpreterPaymentsStatement(page, params) // Assuming API method exists
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Async) {
          return result?.data?.data;
        } else {
          dispatch(setPaymentStatements(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Async) {
          return result?.data?.data;
        } else {
          dispatch(setPaymentStatements(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Async) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const markPaymentAsPaid = (id) => async (dispatch) => {
  try {
    const result = await Api.markInterpreterPaymentAsPaid(id) // Assuming API method exists
    return result?.data;
  } catch (error) {
    console.log("error", error)
  }
}

export const { setPaymentStatements, clearAllPaymentStatement, setLoader, setError, setMorePaymentStatements } = paymentStatementSlice.actions

export default paymentStatementSlice.reducer
export const paymentStatementSelector = state => state.paymentStatements